export default __webpack_public_path__ + "media/images/react_icons/checkout_radio_checked-a318fc1c8e5ccc6ebf37aafbd670b04c.svg";